module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/arrow_right-311dee208334025a45cdb92922221bee.png";